/*
status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import JourneyRequestAPI from '../api/journeyRequest';

const state = {
    journeyRequests: [],
    journeyRequestsLoadStatus: 0,
    journeyRequestAddStatus: 0,
    journeyRequestDeleteStatus: 0,
    journeyRequest: {},
    journeyRequestLoadStatus: 0,

    showJourneyRequestModal: false,
};

const actions = {
    loadJourneyRequests ( { commit } ){
        return new Promise((resolve, reject) => {
            commit( 'setJourneyRequestsLoadStatus', 1 );

            JourneyRequestAPI.getJourneyRequests()
                .then( function( response ){
                    commit( 'setJourneyRequests', response.data.data );
                    commit( 'setJourneyRequestsLoadStatus', 2 );
                    resolve();
                })
                .catch( error => {
                    console.log(error);
                    commit( 'setJourneyRequests', [] );
                    commit( 'setJourneyRequestsLoadStatus', 3 );
                    reject();
                });
        });
    },
    reloadJourneyRequests ( { commit } ){
        return new Promise((resolve, reject) => {
            JourneyRequestAPI.getJourneyRequests()
                .then( function( response ){
                    commit( 'setJourneyRequests', response.data.data );
                    resolve();
                })
        });
    },
    loadJourneyRequest ( { commit }, id ){
        return new Promise((resolve, reject) => {
            commit( 'setJourneyRequest', {} );
            commit( 'setJourneyRequestLoadStatus', 1 );

            JourneyRequestAPI.getJourneyRequest( id )
                .then( function( response ){
                    commit( 'setJourneyRequest', response.data.data );
                    commit( 'setJourneyRequestLoadStatus', 2 );
                    resolve();
                })
                .catch( error => {
                    console.log(error);
                    commit( 'setJourneyRequest', {} );
                    commit( 'setJourneyRequestLoadStatus', 3 );
                    reject();
                });
        });
    },
    addJourneyRequest ( { commit, dispatch }, form ){
        return new Promise((resolve, reject) => {
            commit( 'setJourneyRequestAddStatus', 1 );

            JourneyRequestAPI.postJourneyRequest( form )
                .then( function( response ){
                    commit( 'setJourneyRequestAddStatus', 2 );
                    dispatch( 'loadJourneyRequests');
                    resolve();
                })
                .catch( function(){
                    commit( 'setJourneyRequestAddStatus', 3 );
                    reject();
                });
        });
    },
    deleteJourneyRequest ( { commit, dispatch }, id ){
        return new Promise((resolve, reject) => {
            commit( 'setJourneyRequestDeleteStatus', 1 );

            JourneyRequestAPI.deleteJourneyRequest(id)
                .then( function( response ){
                    commit( 'setJourneyRequestDeleteStatus', 2 );
                    dispatch( 'loadJourneyRequests');
                    resolve();
                })
                .catch( function(){
                    commit( 'setJourneyRequestDeleteStatus', 3 );
                    reject();
                });
        });
    },

    updateShowJourneyRequestModal( { commit }, value ){
        commit( 'setShowJourneyRequestModal', value );
    }
};

const mutations = {
    setJourneyRequests( state, data ){
        state.journeyRequests = data;
    },
    setJourneyRequestsLoadStatus( state, status ){
        state.journeyRequestsLoadStatus = status;
    },
    setJourneyRequestAddStatus( state, status ){
        state.journeyRequestAddStatus = status;
    },
    setJourneyRequestDeleteStatus( state, status ){
        state.journeyRequestDeleteStatus = status;
    },
    setJourneyRequest( state, data ){
        state.journeyRequest = data;
    },
    setJourneyRequestLoadStatus( state, status ){
        state.journeyRequestLoadStatus = status;
    },
    setShowJourneyRequestModal( state, status ){
        state.showJourneyRequestModal = status;
    },
};

const getters = {
    getJourneyRequests( state ){
        return state.journeyRequests.map(journeyRequest => mapToRow(journeyRequest))
    },
    getJourneyRequest( state ){
        if (Object.entries(state.journeyRequest).length !== 0) {
            const row = mapToRow(state.journeyRequest);
            const journeys = state.journeyRequest.journeys.map(journey => mapToJourneyRow(journey));
            return Object.assign(row, {journeys: journeys});
        }
        return {};
    },
};

export const journeyRequests = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}

function mapToRow(journeyRequest) {
    return {
        id: journeyRequest.id,
        placeOriginName: journeyRequest.place_origin.name,
        placeDestinationName: journeyRequest.place_destination.name,
        start: moment(journeyRequest.time_start),
        end: moment(journeyRequest.time_end),
        processed: journeyRequest.processed,
    }
}

function mapToJourneyRow(journey) {
    let row = {
        id: journey.id,
        truck_plate: journey.truck_plate,
        truck_total_tare: journey.total_tare_weight,
        time_start: moment(journey.start_time).format('YYYY-MM-DD HH:mm:ss'),
        time_start_moment: moment(journey.start_time),
        driver_tcp_quantity: journey.driver_tcp_quantity !== null? journey.driver_tcp_quantity : 'N/A',
    };
    if (journey.capacity_prediction !== null && journey.capacity_prediction.status === 1) {
        const boxWhiskerPrediction = {
            gvm: journey.capacity_prediction.gvm,
            payload_weight: journey.capacity_prediction.payload,
            tcp_quantity: journey.capacity_prediction.cages_quantity,
            available_tcp_quantity: journey.capacity_prediction.max_cages_quantity - journey.capacity_prediction.cages_quantity,
            payload_percentage: Math.round(journey.capacity_prediction.full_percentage / 10) * 10,
            method_name: journey.capacity_prediction.method_name,
        };
        Object.assign(row, boxWhiskerPrediction);
    } else {
        const boxWhiskerPrediction = {
            gvm: 'N/A',
            payload_weight: 'N/A',
            tcp_quantity: 'N/A',
            available_tcp_quantity: 'N/A',
            payload_percentage: 'N/A',
            method_name: 'N/A',
        };
        Object.assign(row, boxWhiskerPrediction);
    }
    return row;
}
